export default "__VITE_ASSET__CCstMywL__"